$(document).ready(function(){!function(){"use strict";var e=document.querySelector(".cookiealert"),t=document.querySelector(".acceptcookies");e&&(e.offsetHeight,function(e){for(var t="acceptCookies=",n=decodeURIComponent(document.cookie).split(";"),s=0;s<n.length;s++){for(var o=n[s];" "===o.charAt(0);)o=o.substring(1);if(0===o.indexOf(t))return o.substring(t.length,o.length)}return""}()||e.classList.add("show"),t.addEventListener("click",function(){!function(e,t,n){var s=new Date;s.setTime(s.getTime()+31536e6);var o="expires="+s.toUTCString();document.cookie="acceptCookies=true;"+o+";path=/"}(),e.classList.remove("show"),window.dispatchEvent(new Event("cookieAlertAccept"))}))}(),function(){"use strict";var e={events:["load","orientationchange","resize","scroll"],setOffset:function(t){e.offset=parseInt(t,10)},run:function(){var t,n=document.querySelectorAll(".lazyload");if(n.length>0)for(t=0;t<n.length;t++){var s=n[t],o=s.getAttribute("class").split(" "),i=o.indexOf("lazyBG"),r=s.getAttribute("data-src"),a=s.hasAttribute("data-srcset")?s.getAttribute("data-srcset"):null;s.getBoundingClientRect().top<=window.innerHeight+e.offset&&null!==s.offsetParent&&(i>-1&&(s.style.backgroundImage="url("+r+")"),i<=-1&&(r&&(s.src=r),a&&(s.srcset=a,s.removeAttribute("data-srcset")),"VIDEO"===s.tagName&&s.play()),o.splice(o.indexOf("lazyload"),1),s.setAttribute("class",o.join(" ")),s.removeAttribute("data-src"))}else for(t=0;t<e.events.length;t++)window.removeEventListener(e.events[t],e.run)},init:function(t){var n=document.querySelector("script#lazyloadjs");"number"!=typeof t&&(t=200),n&&n.hasAttribute("data-offset")&&(t=n.getAttribute("data-offset")),e.setOffset(t);for(var s=0;s<e.events.length;s++)window.addEventListener(e.events[s],e.run,!1);e.run()}};e.init()}(),jQuery.event.special.touchstart={setup:function(e,t,n){this.addEventListener("touchstart",n,{passive:!t.includes("noPreventDefault")})}},jQuery.event.special.touchmove={setup:function(e,t,n){this.addEventListener("touchmove",n,{passive:!t.includes("noPreventDefault")})}},jQuery.event.special.wheel={setup:function(e,t,n){this.addEventListener("wheel",n,{passive:!0})}},jQuery.event.special.mousewheel={setup:function(e,t,n){this.addEventListener("mousewheel",n,{passive:!0})}}}),
  //document.getElementById("instructionsSpan").onclick=function(){location.href="/pages/personaliseer-je-cloudpillo"},
  $(".logo__navbar").click(function(){location.href="/pages/personaliseer-je-cloudpillo"});


var mba = document.querySelector('.mb a');
if(mba) {
	mba.onclick = function(e) {
            e.preventDefault();
          
          
         document.querySelector('#reviews').scrollIntoView({ 
           behavior: 'smooth'
         });
          
        };
}



 // Coundown 
    countIt();

function countIt(){
	//var year = moment().format('YYYY');
	//var month = moment().format('MM');
	//var day = moment().format('D');
    year = 2022;
    month = 05;
    day = 8;
    hours = 23;
    minutes = 59;
    seconds = 59;

    setTimeout(function(){
    endDate = new Date(year, (month - 1), day, hours, minutes, seconds, 00);
    thisDate  = new Date();
    thisDate  = new Date(thisDate.getFullYear(), thisDate.getMonth(), thisDate.getDate(), thisDate.getHours(), thisDate.getMinutes(), thisDate.getSeconds(), 00, 00);

    var daysLeft = parseInt((endDate-thisDate)/86400000);
    var hoursLeft = parseInt((endDate-thisDate)/3600000); 
    var minutsLeft = parseInt((endDate-thisDate)/60000);
    var secondsLeft = parseInt((endDate-thisDate)/1000);

    seconds = minutsLeft*60;
    seconds = secondsLeft-seconds;

    minutes = hoursLeft*60;
    minutes = minutsLeft-minutes;

    hours = daysLeft*24;
    hours = (hoursLeft-hours) < 0 ? 0 : hoursLeft-hours;

    days = daysLeft;

    startCount(days, hours, minutes,seconds);
    }, 1000);
}

function startCount(days, hours, minutes, seconds){
    var count = document.getElementById("counter");
    if (count) {
        count.innerHTML= "<span class='count__row'><span class='item'><span class='mn'>"+ day+"d</span></span> <span class='item'><span class='mn'>"+ hours+"h</span></span> <span class='item'><span class='mn'>"+minutes+"m</span></span> <span class='item'><span class='mn'>"+seconds + "s</span></span></span>";

        //document.getElementById("counterDesctope").innerHTML = "<div class='count__row'><div class='item'><div class='mn'>" + hours + "</div><div class='tim'>hours</div></div> <div class='item'><div class='mn'>" + minutes + "</div><div class='tim'>mins</div></div> <div class='item'><div class='mn'>" + seconds + "</div><div class='tim'>secs</div></div></div>";
    }
    countIt();
}


function animate(elem, style, unit, from, to, time, prop) {
  if (!elem) {
    return;
  }
  var start = new Date().getTime(),
    timer = setInterval(function() {
      var step = Math.min(1, (new Date().getTime() - start) / time);
      if (prop) {
        elem[style] = (from + step * (to - from)) + unit;
      } else {
        elem.style[style] = (from + step * (to - from)) + unit;
      }
      if (step === 1) {
        clearInterval(timer);
      }
    }, 25);
  if (prop) {
    elem[style] = from + unit;
  } else {
    elem.style[style] = from + unit;
  }
}
 